import { trackEvent } from "src/Amplitude";
import {
  Box,
  Slider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Button,
  Stack,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  setFilterValue,
  useTreeMapFilterState,
} from "src/store/features/MarketTreeMapFilter.slice";
import { useAppDispatch } from "src/store/store";
import { MarketTreeMapStyle } from "./MarketTreeMap.styles";

const MarketTreeMapSlider = () => {
  const classes = MarketTreeMapStyle();
  const dispatch = useAppDispatch();
  const { minMaxValue } = useTreeMapFilterState();
  const [value, setValue] = useState<number[]>([0, 500000000000]);
  const theme = useTheme();

  const handleChange = (event: Event, newValue: number | number[], activeThumb: number) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    event.preventDefault();

    if (activeThumb === 0) {
      setValue([Math.min(newValue[0], value[1]), value[1]]);
    } else {
      setValue([value[0], Math.max(newValue[1], value[0])]);
    }
  };

  const currencyFormat = (value: number): string => {
    const formatter = Intl.NumberFormat("en", {
      notation: "compact",
      style: "currency",
      currency: "USD",
    });
    let n = formatter.format(value);
    return n;
  };

  const handleApplyBtn = (value: number[]) => {
    trackEvent("Select_Sectors_Range", { value }, "Markets");
    dispatch(setFilterValue(value));
  };

  // If data is loaded set the min and max slider values.
  useEffect(() => {
    if (minMaxValue) {
      let arr = [];
      arr[0] = minMaxValue.min;
      arr[1] = minMaxValue.max;
      setValue(arr);
    }
  }, [minMaxValue]);

  return (
    <FormControl size="small" sx={{ width: { xs: "100%", sm: "100%", md: "100%" } }}>
      <InputLabel shrink={false} id="remove-coin-chip-label">
        Range
      </InputLabel>
      <Select
        onClick={() => trackEvent("Select_Market_Sectors_Page_Advanced_Options_Range")}
        value=""
        sx={{
          "&.MuiOutlinedInput-root": {
            "& fieldset": {},
            "&:hover fieldset": {
              borderColor: theme.palette.secondary.main,
            },
            "&.Mui-focused fieldset": {
              borderColor: theme.palette.secondary.main,
            },
          },
        }}>
        <MenuItem value={10}>
          <Box sx={{ width: 300, height: 50 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
              <Stack direction="row" spacing={2}>
                <Typography id="fromLabel">{`From: ${currencyFormat(value[0])} `}</Typography>
                <Typography id="toLabel">{`To: ${currencyFormat(value[1])}`}</Typography>
              </Stack>

              <Button disableRipple variant="contained" onClick={() => handleApplyBtn(value)}>
                Apply
              </Button>
            </Stack>
          </Box>
        </MenuItem>

        <Box sx={{ margin: 2 }}>
          <Slider
            id="rangeSlider"
            sx={{ width: 300, height: 3 }}
            className={classes.slider}
            onChange={handleChange}
            min={minMaxValue.min}
            max={minMaxValue.max}
            value={value}
            valueLabelDisplay="auto"
          />
        </Box>
      </Select>
    </FormControl>
  );
};

export default MarketTreeMapSlider;
